(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateCountdown(element) {
    const endDateValue = element.dataset.endDate;

    if (!endDateValue) return;

    const endDate = new Date(endDateValue).getTime();
    const distance = endDate - Date.now();

    const daysElement = element.querySelector('[data-days]');
    const hoursElement = element.querySelector('[data-hours]');
    const minutesElement = element.querySelector('[data-minutes]');
    const secondsElement = element.querySelector('[data-seconds]');

    if (
      !daysElement ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      return;
    }

    if (distance <= 0) {
      daysElement.textContent = '00';
      hoursElement.textContent = '00';
      minutesElement.textContent = '00';
      secondsElement.textContent = '00';

      element.classList.add('is-expired');
      return;
    }

    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    daysElement.textContent = pad(days);
    hoursElement.textContent = pad(hours);
    minutesElement.textContent = pad(minutes);
    secondsElement.textContent = pad(seconds);

    element.classList.remove('is-expired');
  }

  function initCountdowns() {
    document
      .querySelectorAll('.dokany-card-countdown')
      .forEach(updateCountdown);
  }

  document.addEventListener('DOMContentLoaded', initCountdowns);
  document.addEventListener('shopify:section:load', initCountdowns);

  setInterval(initCountdowns, 1000);
})();